export default __webpack_public_path__ + "static/media/SWETH.95fa4f13.svg";